import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowSplitDown1"><Path d="M3.75 14.75V20.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M14.75 20.25H20.25V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M12 12V3.75M12 12L4.5 19.5M12 12L19.5 19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconArrowSplitDown1;
